export const data = {
	data() {
		return {
			headerList: [
				// {
				// 	prop: 'order_no',
				// 	label: '订单编号'
				// },
				{
					prop: 'product_title',
					label: '课程标题',
					width: 200
				},
				{
					prop: 'pay_amount',
					label: '支付金额',
					align: 'center',
					width: 120
				},
				// {
				// 	prop: 'nick_nake',
				// 	label: '买家昵称'
				// },
				// {
				// 	prop: 'pay_amount',
				// 	label: '订单金额'
				// },
				// {
				// 	prop: 'pay_time',
				// 	label: '支付时间'
				// },
				{
					prop: 'status',
					label: '订单状态',
					width: 100
				},
				// {
				// 	prop: 'talent_name',
				// 	label: '推广人快手昵称',
				// 	width: 150
				// },
				{
					prop: 'nick_nake',
					label: '购买人',
					width: 140
				},
				{
					prop: 'author_income',
					label: '实际收益',
					width: 130
				},
				{
					prop: 'pay_channel',
					label: '支付来源',
					width: 80
				}
			]
		}
	}
}
